// @ts-nocheck
import { easeEasy } from '@ingka/variables';
export const animationStates = {
    STATIC_ZERO: 'STATIC_ZERO',
    PREPARE_ANIMATE_FROM_ZERO: 'PREPARE_ANIMATE_FROM_ZERO',
    ANIMATING_TO_AUTO: 'ANIMATING_TO_AUTO',
    STATIC_AUTO: 'STATIC_AUTO',
    PREPARE_ANIMATE_FROM_AUTO: 'PREPARE_ANIMATE_FROM_AUTO',
    ANIMATING_TO_ZERO: 'ANIMATING_TO_ZERO'
};
const collapsedStyles = {
    height: 0,
    opacity: 0,
    overflow: 'hidden'
};
export const getStyles = {
    [animationStates.STATIC_ZERO]: () => collapsedStyles,
    [animationStates.PREPARE_ANIMATE_FROM_ZERO]: () => collapsedStyles,
    [animationStates.ANIMATING_TO_AUTO]: (duration, height) => {
        return {
            height: height,
            transition: `all ${duration}ms ${easeEasy}`,
            overflow: 'hidden'
        };
    },
    [animationStates.STATIC_AUTO]: () => null,
    [animationStates.PREPARE_ANIMATE_FROM_AUTO]: (_, height) => {
        return {
            height: height,
            overflow: 'hidden'
        };
    },
    [animationStates.ANIMATING_TO_ZERO]: (duration) => {
        return {
            height: 0,
            opacity: 0,
            overflow: 'hidden',
            transition: `all ${duration}ms ${easeEasy}`
        };
    }
};
